import React from 'react';
import logoBlack from '../../../assets/logo-noir.png';

import CONFIG from '../../../config';
import WidgetInputText from '../../../components/widgets/WidgetInputText';

import { useNavigate } from 'react-router-dom';
import axios from "axios";
import Base64 from 'crypto-js/enc-base64';
import sha256 from 'crypto-js/sha256';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';


function Connexion() {
  const navigate = useNavigate();

  React.useEffect(() => {
    axios.get(CONFIG.API_URL + '/api/me', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            if (response.data.roles.role_client)
              window.location.replace(CONFIG.BASE_URL + "/client/dossier");
            else
              window.location.replace(CONFIG.BASE_URL + "/intranet/vue_ensemble");
            break;

          default:
            break;
        }
      })
      .catch((e) => {

      });
  }, []);

  const [email, setEmail] = React.useState(null);
  const [motDePasse, setMotDePasse] = React.useState(null);
  const [connexionValid, setConnexionValid] = React.useState(false);
  const formConnexion = [[email, setEmail], [motDePasse, setMotDePasse]];


  React.useEffect(() => {
    setConnexionValid(false);

    if (email === null || email.value === '')
      return;

    if (motDePasse === null || motDePasse.value === '')
      return;

    setConnexionValid(true);
  }, formConnexion.map((x) => x[0]));


  const submitFormConnexion = () => {
    let payload = {};

    if (email !== null && motDePasse !== null) {
      payload['username'] = email.value;
      payload['password'] = Base64.stringify(sha256(motDePasse.value));
      payload['grant_type'] = 'password';
    }

    axios.post(CONFIG.API_URL + '/api/token', payload, { headers: { "Content-Type": "application/x-www-form-urlencoded" } })
      .then((response) => {
        switch (response.status) {
          case 200:
            localStorage.setItem('token', response.data.access_token);
            if (response.data.role_client)
              window.location.replace(CONFIG.BASE_URL + "/client/dossier");
            else
              window.location.replace(CONFIG.BASE_URL + "/intranet/vue_ensemble");
            break;
          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          case 401:
            setEmail((s) => ({ ...s, error: true, errorMessage: null }));
            setMotDePasse((s) => ({ ...s, error: true, errorMessage: response.data.detail }));
            break;
          case 403:
            setEmail((s) => ({ ...s, error: true, errorMessage: null }));
            setMotDePasse((s) => ({ ...s, error: true, errorMessage: response.data.detail }));
            break;
          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  };


  return (
    <>
      <form>
        <div className='m-6 grid grid-cols-12 gap-x-4 shrink-0 p-6 max-w-lg mx-auto bg-white my-shadow'>
          <div className='col-start-3 col-span-8 w-full item-center mb-6'>
            <img src={logoBlack} alt="Logo" />
          </div>

          <div className='col-span-12 w-full mb-2 text-center'>
            <h1>Connexion</h1>
          </div>

          <div className='col-start-2 col-span-10 w-full mb-6 text-center'>
            Connectez-vous à votre espace Mouv'Immo
          </div>

          <div className='col-start-2 col-span-10 w-full mb-4'>
            <WidgetInputText state={email} setState={setEmail} id={'email'} text={"Email"} regex={"^.+@.+$"} regex_helper={"Adresse email non-valide"} />
          </div>

          <div className='col-start-2 col-span-10 w-full mb-4'>
            <WidgetInputText state={motDePasse} setState={setMotDePasse} id={'mot_de_passe'} text={"Mot de passe"} type={'password'} />
          </div>

          <div className='col-start-2 col-span-5 w-full text-left text-xs'>
            {/* <Link className='text-xs' color='inherit' href={CONFIG.BASE_URL + "/inscription_client"}>Pas encore de compte ?</Link>
          <br></br> */}
            <Link className='text-xs' color='inherit' href={CONFIG.BASE_URL + "/mdp_oublie"}>Mot de passe oublié ?</Link>
            <br></br>
            <Link className='text-xs' color='inherit' href={CONFIG.BASE_URL + "/renvoyer_mail"}>Mail de vérification non reçu ?</Link>
          </div>

          <div className='col-start-7 col-span-5 w-full text-right'>
            <Button className='w-full' type="submit" variant='contained' disabled={!connexionValid} onClick={(e) => {e.preventDefault(); submitFormConnexion();}}>
              Se connecter
            </Button>
          </div>
          <div className='col-start-7 col-span-5 w-full text-right mt-2'>
            <Button className='w-full' variant='outlined' onClick={() => navigate("/inscription_client")}>
              Créer un compte
            </Button>
          </div>
        </div>
      </form>
    </>
  );
}

export default Connexion;